import React, { FC } from 'react';
import styled from 'styled-components';
import * as styles from './PaymentPlans.styles';
import { PaymentPlansProps } from './models';

export const PaymentPlans = styled<FC<PaymentPlansProps>>(({ className, children }) => {
  return <div {...{ className }}>{children}</div>;
})`
  ${styles.PaymentPlans}
`;
